import { CheckIcon } from "@heroicons/react/24/outline"

interface SetupStepsProps {
  steps: readonly string[]
  currentStep: number
  title?: string
}

const SetupSteps = ({
  steps,
  currentStep,
  title = "Setup steps",
}: SetupStepsProps) => {
  return (
    <aside className="w-full bg-white rounded-md py-4 px-4 md:py-6 md:px-5 lg:w-52 lg:shrink-0 self-stretch">
      <p className="text-lg font-bold text-slate-900 mb-3 md:mb-5">{title}</p>
      <ol className="flex flex-col gap-4">
        {steps.map((label, index) => {
          const isActive = index === currentStep
          const isCompleted = index < currentStep
          const isFuture = index > currentStep
          return (
            <li
              key={label}
              className="flex items-center gap-3"
            >
              <div className="flex items-center shrink-0">
                <span
                  className={`flex h-5 w-5 items-center justify-center rounded-full ${
                    isCompleted
                      ? "bg-[#004AF5]"
                      : "border border-slate-300 bg-white"
                  }`}
                >
                  {isCompleted && <CheckIcon className="h-3 w-3 text-white" />}
                </span>
              </div>
              <p
                className={`text-sm m-0 ${
                  isActive
                    ? "text-slate-900 font-bold"
                    : isFuture
                    ? "text-slate-400"
                    : "text-slate-900 font-semibold"
                }`}
              >
                {label}
              </p>
            </li>
          )
        })}
      </ol>
    </aside>
  )
}

export default SetupSteps
